export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ../~/rmc-feedback/es/index.js
// module id = 2868
// module chunks = 1